interface IFile {
  id: number;
  nome: string;
  tipo: string;
  url: string;
  tipoDocumento: number;
  dataUpload: string;
}

interface IFileType {
  title: string;
  files: IFile[];
}

interface IListFiles {
  sucesso: boolean;
  listFiles: IFile[];
}

export enum FileTypeDefinition {
  Prescription = 1,
  Certificate = 2,
  Advice = 3,
  ExamRequest = 4,
  ExamResult = 5,
  Receipt = 6,
}

export type {
  IFile,
  IFileType,
  IListFiles,
}